import { CheckCard } from "@/components";
import { FONT, MEDIA } from "@/styles/common";
import theme from "@/styles/theme";
import { replaceBuyerInfo } from "@/utils";
import { Divider, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const BookingList = ({ data }: { data: any }) => {
    const { isMobile } = MEDIA();

    return (
        <Flex w="100%" flexDir="column" rowGap="24px">
            <Text w="100%" fontSize="24px" textAlign="left" fontWeight="700">
                예약 조회결과
            </Text>
            <CustomFlex w="100%" isMobile={isMobile} flexDir="column" rowGap="24px" p={isMobile ? "0" : "24px"}>
                <Flex w="100%" flexDir="column" rowGap="32px">
                    {data.roomList.map((it: any, index: number) => (
                        <>
                            <CheckCard key={index} roomList={it} status={data.status} />
                            <CustomDivider _last={{ display: "none" }} />
                        </>
                    ))}
                </Flex>
                <CustomDivider />
                <Flex
                    width="100%"
                    justifyContent={"space-between"}
                    flexDir={isMobile ? "column-reverse" : "row"}
                    alignItems={isMobile ? "flex-start" : "center"}
                    rowGap={isMobile ? "16px" : "auto"}
                >
                    <Flex w="100%" flexDir={isMobile ? "column" : "row"} rowGap={isMobile ? "8px" : "auto"}>
                        {isMobile && (
                            <>
                                <CustomBuyerText>예약자 정보</CustomBuyerText>
                                <CustomDivider />
                            </>
                        )}
                        <Flex columnGap="20px" rowGap="4px" flexDir={isMobile ? "column" : "row"}>
                            <Text fontWeight="500">예약번호 : {data.orderNum}</Text>
                            <Text fontWeight="500">
                                예약자 : {replaceBuyerInfo({ str: data.orderName, type: "name" })}
                            </Text>
                            <Text fontWeight="500">
                                연락처 : {replaceBuyerInfo({ str: data.orderTel, type: "phone" })}
                            </Text>
                        </Flex>
                    </Flex>
                    <Flex
                        alignItems="center"
                        width={isMobile ? "100%" : "280px"}
                        p={isMobile ? "0" : "0 16px"}
                        boxSizing={"border-box"}
                        justifyContent={"space-between"}
                    >
                        <CustomTotalFee>총 결제금액</CustomTotalFee>
                        <Flex alignItems="center" gap="4px" justifyContent={"space-between"}>
                            <Text fontSize="24px" color={theme.COLOR.pink[200]} lineHeight="1.5" fontWeight={"700"}>
                                {Number(data.paymentPrice).toLocaleString()}
                            </Text>
                            <Text>원</Text>
                        </Flex>
                    </Flex>
                </Flex>
            </CustomFlex>
        </Flex>
    );
};

const CustomFlex = styled(Flex)<{ isMobile: boolean }>`
    border: ${({ isMobile, theme }) => (isMobile ? "none" : `1px solid ${theme.COLOR.gray[300]}`)};
    border-radius: 16px;
`;

const CustomDivider = styled(Divider)`
    color: ${({ theme }) => theme.COLOR.gray[300]};
`;

const CustomTotalFee = styled(Text)`
    ${FONT("pretendard", 16, 700)}
`;

const CustomBuyerText = styled(Text)`
    ${FONT("pretendard", 16, 700)}
`;
